// Job page: sidebar toggle, My Jobs toggle, and job row expand/collapse.
// Form auto-submit and debounce are handled by auto_search.js.

const SIDEBAR_KEY = "jobs_sidebar_visible";

// Applies the persisted filter sidebar state and optionally saves user changes.
function applySidebarState(visible, persist = false) {
  const row = document.getElementById("job-search-row");
  if (!row) return;
  row.classList.toggle("sidebar-hidden", !visible);
  const icon = document.getElementById("sidebar-toggle-icon");
  if (icon) {
    icon.classList.toggle("fa-eye-slash", visible);
    icon.classList.toggle("fa-eye", !visible);
  }
  // Only write to localStorage when explicitly persisting a user action,
  // not on every frame load / page restore.
  if (persist) localStorage.setItem(SIDEBAR_KEY, visible ? "1" : "0");
}

// Restore sidebar state on full page load
document.addEventListener("turbo:load", function () {
  applySidebarState(localStorage.getItem(SIDEBAR_KEY) !== "0");
});

// Re-sync sidebar icon after frame reloads (button re-renders inside the frame)
document.addEventListener("turbo:frame-load", function (e) {
  if (e.target.id !== "job-results") return;
  applySidebarState(localStorage.getItem(SIDEBAR_KEY) !== "0");
});

// Unified click handler — one listener handles all delegated clicks
document.addEventListener("click", function (e) {
  // Sidebar toggle
  if (e.target.closest("#sidebar-toggle")) {
    const row = document.getElementById("job-search-row");
    if (!row) return;
    const next = row.classList.contains("sidebar-hidden");
    applySidebarState(next, true);
    return;
  }

  // My Jobs toggle — flips the hidden input and submits into the Turbo Frame.
  // Cancels any pending auto_search.js debounce to avoid a double submit.
  if (e.target.closest("#my-jobs-btn")) {
    e.preventDefault();
    const input = document.getElementById("my-jobs-input");
    const btn = document.getElementById("my-jobs-btn");
    const form = document.querySelector("form[data-turbo-frame='job-results']");
    if (!input || !form) return;
    form._cancelDebounce?.();
    const active = input.value === "true";
    input.value = active ? "" : "true";
    btn?.classList.toggle("active", !active);
    form.requestSubmit();
    return;
  }

  // Job row expand/collapse
  const toggle = e.target.closest(".job-expand-toggle");
  if (toggle) {
    const detailRow = document.getElementById(toggle.dataset.target);
    if (!detailRow) return;
    const expanded = detailRow.classList.toggle("expanded");
    toggle.classList.toggle("expanded", expanded);
  }
});
